var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, override } from 'mobx';
import { QuestionAnswerState } from '../../../classes/learnware/LearnwareEnums';
import { QuestionScore } from '../../../classes/question/modules/QuestionScore';
export class OrderedChoiceScore extends QuestionScore {
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get question() {
        return this.parent;
    }
    get maxPoints() {
        return this.question.orderedTask.steps.length;
    }
    get reachedPoints() {
        return this.question.orderedTask.steps.map(step => step.stepEval.reachedPoints).reduce((a, b) => a + b, 0);
    }
    get progressiveReachablePoints() {
        return this.question.orderedTask.steps.filter(step => step.stepProgress.isStepCompleted).length;
    }
    get shouldSetCompletedTimestamp() {
        if (!this.question.answer)
            return false;
        return (!this.question.answer.completeDate &&
            this.question.answeringState.currentAnswerState === QuestionAnswerState.Answering &&
            this.question.orderedTask.taskProgress.isTaskCompleted);
    }
    get legacyEvalText() {
        return this.question.orderedTask.steps.map(step => step.stepEval.legacyEvalText).join(';');
    }
    set legacyEvalText(t) { }
}
__decorate([
    override
], OrderedChoiceScore.prototype, "maxPoints", null);
__decorate([
    override
], OrderedChoiceScore.prototype, "reachedPoints", null);
__decorate([
    override
], OrderedChoiceScore.prototype, "progressiveReachablePoints", null);
__decorate([
    override
], OrderedChoiceScore.prototype, "shouldSetCompletedTimestamp", null);
